import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/CarDetailsEMI.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/CarDetailsOptions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/CarInspectionReport.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/CarSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/CompareCars.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/MobileButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/buy-used-cars/vehicle/[slug]/_components/TestDriveButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/Contacts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/Icons/IconEye.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ui/tooltip/GenericTooltip.css");
;
import(/* webpackMode: "eager", webpackExports: ["Provider","Root","Trigger","Portal","Content","Arrow"] */ "/app/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
